"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IC3TelemetryEvent;
(function (IC3TelemetryEvent) {
    IC3TelemetryEvent["JoinConversation"] = "JoinConversation";
    IC3TelemetryEvent["RegisterOnNewMessage"] = "RegisterOnNewMessage";
    IC3TelemetryEvent["RegisterOnThreadUpdate"] = "RegisterOnThreadUpdate";
    IC3TelemetryEvent["OnNewMessageFailure"] = "OnNewMessageFailure";
    IC3TelemetryEvent["OnThreadUpdateFailure"] = "OnThreadUpdateFailure";
    IC3TelemetryEvent["SendLiveStateFailure"] = "SendLiveStateFailure";
    IC3TelemetryEvent["JoinConversationV1GetThreadRequestFailed"] = "JoinConversationV1GetThreadRequestFailed";
    IC3TelemetryEvent["UpdateToken"] = "UpdateToken";
    IC3TelemetryEvent["SyncingPollData"] = "SyncingPollData";
    IC3TelemetryEvent["IC3InitializationBegins"] = "IC3InitializationBegins";
    IC3TelemetryEvent["IC3StartedPolling"] = "IC3StartedPolling";
    IC3TelemetryEvent["IC3StoppedPolling"] = "IC3StoppedPolling";
    IC3TelemetryEvent["IC3EndpointCreationSuccess"] = "IC3EndpointCreationSuccess";
    IC3TelemetryEvent["RedirectOnRequestCreationFailure"] = "RedirectOnRequestCreationFailure";
    IC3TelemetryEvent["ResetOnRequestCreationFailure"] = "ResetOnRequestCreationFailure";
    IC3TelemetryEvent["MaxRetryCountReachedForRedirect"] = "MaxRetryCountReachedForRedirect";
    IC3TelemetryEvent["OnRequestCreationFailureRedirect"] = "OnRequestCreationFailureRedirect";
    IC3TelemetryEvent["OnRequestCreationSuccessRedirect"] = "OnRequestCreationSuccessRedirect";
    IC3TelemetryEvent["ErrorDuringPolling"] = "ErrorDuringPolling";
    IC3TelemetryEvent["HTTPRequestFailed"] = "HTTPRequestFailed";
    IC3TelemetryEvent["HTTPRequestUnusualResponse"] = "HTTPRequestUnusualResponse";
})(IC3TelemetryEvent || (IC3TelemetryEvent = {}));
exports.default = IC3TelemetryEvent;
//# sourceMappingURL=IC3TelemetryEvent.js.map